import { handleActions } from '@mendeley-internal/lib-js-redux-actions';
import { getStats } from '../actions/stats';

const isTimeout = ({ code }) => code === 'ECONNABORTED';

const defaultStats = {
  totalCitations: null,
  totalViews: null
};

export default handleActions({
  [getStats]: {
    first(state, { meta: { documentId } }) {
      return {
        ...state,
        [documentId]: {}
      };
    },
    next(state, { payload, meta: { documentId } }) {
      return {
        ...state,
        [documentId]: {
          ...defaultStats,
          ...Array.isArray(payload) ? payload[0] : payload,
        }
      };
    },
    throw(state, { payload, meta: { documentId } }) {
      return {
        ...state,
        [documentId]: {
          error: true,
          timeout: isTimeout(payload)
        }
      };
    }
  }
}, {});



// WEBPACK FOOTER //
// ./src/universal/ui/reducers/stats.js